import { FormBase } from 'core/components';

export default class TaskCommentForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'message',
                    placeholder: 'Write a comment...',
                    rules: 'required|string'

                },
                {
                    name: 'authorId',
                    rules: 'required|string'
                },
                {
                    name: 'facilityScheduleDateId',
                    rules: 'required|string'
                },
            ],
        };
    }
}
